module.exports = __webpack_public_path__ + "img/firebase.c24b6b9c.png";